export const sortByName =
  (lang: string) =>
  <T extends { name: string }>(a: T, b: T) => {
    return a.name.localeCompare(b.name, lang, { sensitivity: 'base' });
  };
